import { UseFormRegister, UseFormSetValue } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { QuestionnaireImportance } from "@/pages/Public/pages/Questionnaire/enum/QuestionnaireImportance.enum";

import FormTextField from "../../../Account/components/FormTextField";
import ImportanceRadioGroup from "../EditableQuestionnaireItem/ImportanceRadioGroup";

interface StepOptionItemProps {
	className?: string;
	nameTitle: string;
	nameImportance: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	error?: any;
	valueImportance?: QuestionnaireImportance;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	register: UseFormRegister<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setValue: UseFormSetValue<any>;
}

export default function StepOptionItem({
	className,
	nameImportance,
	nameTitle,
	setValue,
	error,
	valueImportance,
	register,
}: StepOptionItemProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-questionnaire.${key}`);

	return (
		<div className={className}>
			<FormTextField
				autoComplete="title"
				containerClassName="col-span-7 !mb-0"
				errorMessage={error?.title?.message}
				formRegister={register(nameTitle)}
				label={ts("form-fields.title")}
				showLabel={false}
			/>
			<ImportanceRadioGroup
				errorMessage={error?.type?.message}
				name={nameImportance}
				options={Object.values(QuestionnaireImportance)}
				value={valueImportance}
				onChange={(newValue) => setValue(nameImportance, newValue)}
			/>
		</div>
	);
}
